import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h4`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
`;
